import moment from 'moment-timezone'

export const formatDateForBackend = (date: Date | undefined): string | null => {
  if (!date) return null

  const romania = moment.tz(date, 'Europe/Bucharest')
  const romaniaMidnight = romania.startOf('day')

  return romaniaMidnight.utc().toISOString()
}

export const parseDateFromBackend = (dateString: string | null | undefined): Date | undefined => {
  if (!dateString) return undefined

  const isoDate = new Date(dateString)
  if (!Number.isNaN(isoDate.getTime())) {
    return isoDate
  }

  const parts = dateString.split('-')
  if (parts.length !== 3) return undefined

  const [day, month, year] = parts
  const date = new Date(Number.parseInt(year), Number.parseInt(month) - 1, Number.parseInt(day))

  return Number.isNaN(date.getTime()) ? undefined : date
}
